import React from 'react';
import { connect } from 'react-redux';

import TextArea from '../TextArea';
import * as DesignerState from '../../../../state/reducer/designer/designer';
import * as Utils from '../../../../lib/designerUtils';
import Console from '../../../../lib/debug';

const MAX_CIRCUIT_INSTRUCTION_LENGTH = 10000;

class BlockInstruction extends React.Component {
    updateInstructions(event) {
        let dispatch = this.props.dispatch;
        let block = this.props.block;

        if (event.target.value !== block.instruction) {
            block.instruction = event.target.value;
            DesignerState.savingState(block, true);
            DesignerState.updateBlock(
                dispatch,
                block,
                'instruction',
                event.target.value
            );
        }
        DesignerState.enableEditing(dispatch, { id: 0 });
    }

    handleKeyUp(event) {
        let dispatch = this.props.dispatch;
        let block = this.props.block;
        let textAreaElement = event.target.id;
        let enableCircuitSave =
            this.props.circuitsEnabled.indexOf(block.id) >= 0;
        clearTimeout(this.typingTimer);
        this.typingTimer = setTimeout(
            () => {
                let idTextArea = textAreaElement;
                let elementTxtArea = document.getElementById(idTextArea);
                let latestInstructions =
                    elementTxtArea && elementTxtArea.value
                        ? elementTxtArea.value
                        : '';
                if (latestInstructions) {
                    this.currentValue = latestInstructions;
                    if (
                        !enableCircuitSave ||
                        this.currentValue !== block.instruction
                    ) {
                        DesignerState.updateBlock(
                            dispatch,
                            block,
                            'instruction',
                            this.currentValue
                        );
                        DesignerState.enableCustomCircuitSave(
                            dispatch,
                            block,
                            true
                        );
                    }
                }
            },
            2000,
            textAreaElement
        );
    }

    render() {
        Console.render('designer.BlockInstruction');
        let block = this.props.block;
        let blockInstructions = null;

        let textareaStyle = {
            resize: 'none',
            minHeight: 76
        };

        let saveCircuit = !block.workout_combo_id ? (
            <div className="save-new-circuit" onClick={this.props.onNewCircuit}>
                <i className="mdi mdi-content-save" />
                <span className="new-circuit-btn">
                    {' '}
                    Save Circuit to Library
                </span>
            </div>
        ) : null;

        this.typingTimer = null;

        if (parseInt(block.plain_text, 10) === 1) {
            let placeholder = Utils.getBlockPlaceholderText(block);
            blockInstructions = (
                <div className="block-instructions">
                    <TextArea
                        label="Circuit Details"
                        count={true}
                        max={MAX_CIRCUIT_INSTRUCTION_LENGTH}
                        ref={this.props.textareaRef}
                        value={block.instruction}
                        placeholder={placeholder}
                        style={textareaStyle}
                        onKeyUp={this.handleKeyUp.bind(this)}
                        blurCallback={this.updateInstructions.bind(this)}
                    />
                    {saveCircuit}
                </div>
            );
        }
        return blockInstructions;
    }
}

let mapStatetoBlockInstructionProps = function(state, ownProps) {
    return {
        block: state.calendar.blockTree[ownProps.block.key],
        circuitsEnabled: state.calendar.uiTree.circuitsEnabled,
        isSaving: state.calendar.uiTree.isSaving,
        ...ownProps
    };
};

export default connect(mapStatetoBlockInstructionProps)(BlockInstruction);
